import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../product/components/templates/Layout'
import '../Dashboard/Dashboard.css'
import CustomTable from '../../product/components/molecules/CustomTable'
import CustomSearch from '../../product/components/molecules/CustomSearch'
import TextField from '@mui/material/TextField'
import PrimaryButton from '../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../product/components/atoms/SecondaryButton'

import { useFormik } from 'formik'
import AlertContext from '../../product/context/alert/alertContext'
import ProductContext from '../../product/context/product/productContext'
import AuctionContext from '../../product/context/auction/auctionContext'
import UserContext from '../../product/context/user/userContext'
import CommonContext from '../../product/context/common/commonContext'
import ReportContext from '../../product/context/report/reportContext'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../product/common/components'
import moment from 'moment'

import CustomDialog from '../../product/components/organisms/Dialog'
import { Button } from '@mui/material'
import Loaders from '../../product/components/molecules/Loaders'

const Listing = (props) => {
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)
    const auctionContext = useContext(AuctionContext)
    const { getAllUsers } = useContext(UserContext)
    const reportContext = useContext(ReportContext)
    const commonContext = useContext(CommonContext)
    const [isLoading, setIsLoading] = useState(true)
    const { setBidHistoryValue } = commonContext
    const { getAllExportDownload } = reportContext
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
    })
    const [bulkPopup, setBulkPopup] = useState(false)

    console.log('global.serverTime', new Date(), global.serverTime)
    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }

    const history = useHistory()
    const { setAlert } = alertContext
    const {
        all_products,
        activelots,
        getAllProducts,
        changeProductStatus,
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
    } = productContext

    const [changeStatus, setChangeStatus] = React.useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [tableBody, setTableBody] = useState([])

    let action = props.match.params.action

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: 'cp.cronUpdateDate, asc',
            filters: {
                market_status: {
                    value: ['open', 'draft'],
                    type: 'array',
                    field: 'p.market_status',
                },
                internalId: {
                    value: '',
                    type: 'in',
                    field: 'cp.internalId',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                fromdate: {
                    value: '',
                    type: 'dategreaterequal',
                    field: 'p.date_closed',
                },
                todate: {
                    value: '',
                    type: 'datesmallerequal',
                    field: 'p.date_closed',
                },
            },
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllProducts(values)
        },
    })

    const formikSelection = useFormik({
        initialValues: {
            action: '',
            project_id: '',
            auction_id: '',
            date_closed: dateTimeFormatFunction(new Date()),
            date_added: dateTimeFormatFunction(new Date()),
            mainUpdate: false,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            if (
                values.action === 'open' ||
                values.action === 'removed' ||
                values.action === 'unsold' ||
                values.action === 'date_closed' ||
                values.action === 'date_added_closed' ||
                values.action === 'relist'
            ) {
                const value = values
                if (value.action === 'date_closed') {
                    value.date_closed = moment(
                        value.date_closed,
                        'MM-DD-YYYY h:mm a'
                    ).format()
                } else if (value.action === 'date_added_closed') {
                    value.date_added = moment(
                        value.date_added,
                        'MM-DD-YYYY h:mm a'
                    ).format()
                    value.date_closed = moment(
                        value.date_closed,
                        'MM-DD-YYYY h:mm a'
                    ).format()
                } else {
                    delete value.date_closed
                    delete value.date_added
                }

                changeProductStatus(value)
            }
        },
    })

    useEffect(() => {
        return () => setIsLoading(false)
    }, [])
    useEffect(() => {
        if (all_products) {
            setTableBody(
                all_products.records.length ? all_products.records : []
            )
        }
        setIsLoading(false)
    }, [all_products])

    const getMultipleAction = () => {
        let actionPush = []
        if (!(action === 'closed')) {
            actionPush.push({
                buttonType: 'edit',
                clickType: 'edit',
                clickID: 'id',
                onclick: onClickEdit,
                tooltipTitle: 'Edit lot',
            })
        }

        return actionPush
    }
    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.filters.fromdate.value = ''
        formik.values.filters.todate.value = ''
        formik.values.filters.searchterm.value = ''
        getAllProducts(formik.values)
        return () => {
            setTableBody([])
        }
    }, [action])

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'bidcount') {
            setBidHistoryValue({
                id,
                proxy: true,
                delete_bid: false,
            })
        } else {
            toggleFullScreenPopup(true, type, id)
        }
    }
    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.project_id = data
        formikSelection.values.mainUpdate = false
        formikSelection.values.date_closed = dateTimeFormatFunction(new Date())
        formikSelection.values.date_added = dateTimeFormatFunction(new Date())
        formikSelection.values.auction_id = ''
        if (
            action === 'open' ||
            action === 'removed' ||
            action === 'unsold' ||
            action === 'relist'
        ) {
            if (action === 'removed') {
                let selectedProjects = tableBody.filter(
                    (filter) =>
                        formikSelection.values.project_id.indexOf(filter.id) !==
                        -1
                )
                let bidsCountCheck = selectedProjects.filter(
                    (filter) => filter.bidscount === 0
                )
                if (
                    bidsCountCheck.length !==
                    formikSelection.values.project_id.length
                ) {
                    setAlert('Listings with bids cannot be deleted', 'error')
                } else {
                    setChangeStatus(true)
                }
            } else {
                setChangeStatus(true)
            }
        } else if (action === 'date_closed') {
            formikSelection.values.mainUpdate = true
            setChangeStatus(true)
        } else if (action === 'date_added_closed') {
            formikSelection.values.mainUpdate = true
            setChangeStatus(true)
        }
    }

    const dateClosed = {
        formik: formikSelection,
        data: [
            {
                label: 'Start date *',
                placeholder: 'Enter Start date',
                type: 'datetime',
                disablePast: true,
                class: `col-12 ${
                    formikSelection.values.mainUpdate &&
                    formikSelection.values.action === 'date_added_closed'
                        ? ''
                        : 'd-none'
                }`,
                name: 'date_added',
            },
            {
                label: 'End Date *',
                placeholder: 'Enter End Date',
                disablePast: true,
                type: 'datetime',
                class: `col-12 ${
                    formikSelection.values.mainUpdate ? '' : 'd-none'
                }`,
                name: 'date_closed',
                minDate: dateTimeFormatFunction(
                    formikSelection.values.date_added
                ),
                minDateMessage: `Date should not be before minimal date ${dateTimeFormatFunction(
                    formikSelection.values.date_added
                )}`,
            },
        ],
    }

    const tableValues = []
    tableValues.push(
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            sortField: 'p.id',
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'internalId',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'NetSuite Internal ID',
        },
        {
            field: 'avatar',
            type: 'imagewithurl',
            folder: 'product',
            firstChild: false,
            sort: false,
            disablePadding: false,
            label: 'Picture',
            custom: true,
        },
        {
            field: 'title',
            type: '',
            firstChild: false,
            sort: true,
            sortField: 'p.title',
            disablePadding: false,
            label: 'Title',
        },
        {
            field: 'auctiontitle',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Auction Title',
        }
    )

    if (action !== 'sold' && action !== 'relisted') {
        tableValues.push(
            {
                field: 'date_added',
                type: 'datetime',
                sort: true,
                firstChild: false,
                disablePadding: false,
                label: 'Start date',
            },
            {
                field: 'date_closed',
                type: 'datetime',
                sort: true,
                firstChild: false,
                disablePadding: false,
                label: 'End date',
            }
        )
    }

    tableValues.push(
        {
            field: 'market_status',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Market Status',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Created At',
        },
        {
            field: 'updated_at',
            type: 'datetime',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Updated At',
        },
        {
            field: 'cronUpdateDate',
            type: 'date',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Cron Update Date',
        },
        {
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        }
    )

    /*if (action === 'open' || action === 'draft') {
        tableValues.push({
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit listing',
        })
    }*/

    const tableActions = []

    if (action === 'draft') {
        tableActions.push(
            {
                label: 'Move to Active',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'open',
            },
            {
                label: 'Change Start and End Date',
                icon: <span className="material-icons">today</span>,
                onclick: onSelectMultiProducts,
                type: 'date_added_closed',
            },
            {
                label: 'Delete',
                icon: <span className="material-icons">delete</span>,
                onclick: onSelectMultiProducts,
                type: 'removed',
            }
        )
    } else if (action === 'open') {
        tableActions.push(
            {
                label: 'Move to Unsold',
                icon: <span className="material-icons">low_priority</span>,
                onclick: onSelectMultiProducts,
                type: 'unsold',
            },
            {
                label: 'Delete',
                icon: <span className="material-icons">delete</span>,
                onclick: onSelectMultiProducts,
                type: 'removed',
            },
            {
                label: 'Change End Date',
                icon: <span className="material-icons">today</span>,
                onclick: onSelectMultiProducts,
                type: 'date_closed',
            }
        )
    } else if (action === 'sold') {
        tableActions.push({
            label: 'Move to Unsold',
            icon: <span className="material-icons">low_priority</span>,
            onclick: onSelectMultiProducts,
            type: 'unsold',
        })
    } else if (action === 'unsold') {
        tableActions.push(
            {
                label: 'Delete',
                icon: <span className="material-icons">delete</span>,
                onclick: onSelectMultiProducts,
                type: 'removed',
            },
            {
                label: 'Relist',
                icon: <span className="material-icons">restart_alt</span>,
                onclick: onSelectMultiProducts,
                type: 'relist',
            }
        )
    }

    const searchInfo = {
        formik: formik,
        data: [
            {
                label: 'Internal ID',
                placeholder: 'Enter a NetSuite internal ID',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'internalId',
                filter: true,
            },
            {
                label: 'Listing Title',
                placeholder: 'Enter listing title',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Closed From Date',
                placeholder: 'Date Ending from',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'fromdate',
                filter: true,
            },
            {
                label: 'Closed To Date',
                placeholder: 'Date Ending To',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'date',
                name: 'todate',
                filter: true,
            },
        ],
    }

    useEffect(() => {
        if (responseStatusProduct) {
            if (responseStatusProduct.status === 'success') {
                if (responseStatusProduct.from === 'productchange') {
                    setChangeStatus(false)
                    getAllProducts(formik.values)
                } else if (responseStatusProduct.from === 'projectAction') {
                    toggleFullScreenPopup(false)
                    getAllProducts(formik.values)
                }
            }
        }
    }, [responseStatusProduct])

    return (
        <Layout>
            <div className="dashboard listing">
                <CustomSearch searchInfo={searchInfo} formik={formik} />
                <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4"></div>
                {isLoading ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <CustomTable
                        formik={formik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={tableActions}
                        allData={all_products}
                        changeTableFunction={getAllProducts}
                    />
                )}
            </div>

            <CustomDialog
                title={'Change product status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="row">{mapData(dateClosed)}</div>
                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}

export default Listing
